// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.right-panel {
  height: 100%;
  display: flex;
  flex-direction: column;
  overflow: hidden;
}

.panel-section {
  border-bottom: 1px solid var(--border-color);
}

/* 팔레트 섹션 */
.palette-section {
  height: auto;
  display: flex;
  flex-direction: column;
}

.empty-palette-message {
  width: 100%;
  text-align: center;
  color: #888888;
  font-size: calc(12px * var(--ui-scale));
  padding: calc(10px * var(--ui-scale));
}

/* 레이어 섹션 */
.layers-section {
  flex: 1 1;
  display: flex;
  flex-direction: column;
  overflow: hidden;
}

.layer-name {
  flex: 1 1;
}`, "",{"version":3,"sources":["webpack://./src/components/RightPanel.css"],"names":[],"mappings":"AAAA;EACE,YAAY;EACZ,aAAa;EACb,sBAAsB;EACtB,gBAAgB;AAClB;;AAEA;EACE,4CAA4C;AAC9C;;AAEA,WAAW;AACX;EACE,YAAY;EACZ,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,cAAc;EACd,uCAAuC;EACvC,qCAAqC;AACvC;;AAEA,WAAW;AACX;EACE,SAAO;EACP,aAAa;EACb,sBAAsB;EACtB,gBAAgB;AAClB;;AAEA;EACE,SAAO;AACT","sourcesContent":[".right-panel {\n  height: 100%;\n  display: flex;\n  flex-direction: column;\n  overflow: hidden;\n}\n\n.panel-section {\n  border-bottom: 1px solid var(--border-color);\n}\n\n/* 팔레트 섹션 */\n.palette-section {\n  height: auto;\n  display: flex;\n  flex-direction: column;\n}\n\n.empty-palette-message {\n  width: 100%;\n  text-align: center;\n  color: #888888;\n  font-size: calc(12px * var(--ui-scale));\n  padding: calc(10px * var(--ui-scale));\n}\n\n/* 레이어 섹션 */\n.layers-section {\n  flex: 1;\n  display: flex;\n  flex-direction: column;\n  overflow: hidden;\n}\n\n.layer-name {\n  flex: 1;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
